import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StreamDescriptionModal.css';
import ReactHtmlParser from 'react-html-parser';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamDescriptionModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isStreamDescriptionModalOpen} toggle={this.props.toggleStreamDescriptionModal} className="modal-stream-code">
		          	<ModalHeader toggle={this.props.toggleStreamDescriptionModal}>{strings.title}</ModalHeader>
					<ModalBody>
						{ReactHtmlParser(this.props.activeEvent.desc)}
					</ModalBody>
					<ModalFooter className="justify-content-center">
						<button
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.toggleStreamDescriptionModal}
						>{strings.close}</button>
					</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

StreamDescriptionModal.propTypes = {
	activeEvent: PropTypes.object,
	isStreamArtistsModalOpen: PropTypes.bool,
	toggleStreamArtistsModal: PropTypes.func
}
 
export default StreamDescriptionModal;


// WEBPACK FOOTER //
// ./src/components/Stream/StreamDescriptionModal/StreamDescriptionModal.js